import { Dispatch } from "redux";
import { thinkApi } from "../../Api/Microservices";
import { buildAppError } from "../../Utils/AppError";
import { SASUrlRequest } from "../../Models/Request/SASUrlRequest";
import {
  CLOSE_RIGHT_SIDEBAR,
  FETCH_SASURL_FAILURE,
  FETCH_SASURL_NEW_WINDOW_SUCCESS,
  FETCH_SASURL_REQUEST,
  FETCH_SASURL_SUCCESS,
  OPEN_RIGHT_SIDEBAR,
  TOGGLE_RIGHT_SIDEBAR,
} from "./RightSidebarTypes";

const setAuthorizationHeader = (token: any) => {
  thinkApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

export const openRightSidebar = () => ({
  type: OPEN_RIGHT_SIDEBAR,
});

export const closeRightSidebar = () => ({
  type: CLOSE_RIGHT_SIDEBAR,
});

export const toggleRightSidebar = () => ({
  type: TOGGLE_RIGHT_SIDEBAR,
});

export const fetchSASUrlRequest = () => ({
  type: FETCH_SASURL_REQUEST,
});

export const fetchSASUrlSuccess = (pdfUrl: any) => ({
  type: FETCH_SASURL_SUCCESS,
  payload: pdfUrl,
});
export const fetchSASUrlNewWindowSuccess = (pdfUrl: any) => ({
  type: FETCH_SASURL_NEW_WINDOW_SUCCESS,
  payload: pdfUrl,
});

export const fetchSASUrlError = (error: any) => ({
  type: FETCH_SASURL_FAILURE,
  payload: error,
});

export const generateSASUrl = (token: any, payload: SASUrlRequest) => {
  return async (dispatch: Dispatch) => {
    if (token) {
      dispatch(fetchSASUrlRequest());
      try {
        setAuthorizationHeader(token);
        const response = await thinkApi.post("/sasurl", payload);
        dispatch(fetchSASUrlSuccess(response.data.sasUrl));
      } catch (error: any) {
        const appError = buildAppError(error, "");
        dispatch(fetchSASUrlError(appError.message));
      }
    }
  };
};

export const generateSASUrlInNewWindow = (
  token: any,
  payload: SASUrlRequest
) => {
  return async (dispatch: Dispatch) => {
    if (token) {
      dispatch(fetchSASUrlRequest());
      try {
        setAuthorizationHeader(token);
        const response = await thinkApi.post("/sasurl", payload);
        dispatch(fetchSASUrlNewWindowSuccess(response.data.sasUrl));
        window.open(`${response.data.sasUrl}`, "_blank");
      } catch (error: any) {
        const appError = buildAppError(error, "");
        dispatch(fetchSASUrlError(appError.message));
      }
    }
  };
};

export const generateSASUrlInNewWindowForAdmin = (
  token: any,
  payload: SASUrlRequest
) => {
  return async (dispatch: Dispatch) => {
    if (token) {
      dispatch(fetchSASUrlRequest());
      try {
        setAuthorizationHeader(token);
        const response = await thinkApi.post("/sasurlforadmin", payload);
        dispatch(fetchSASUrlNewWindowSuccess(response.data.sasUrl));
        window.open(`${response.data.sasUrl}`, "_blank");
      } catch (error: any) {
        const appError = buildAppError(error, "");
        dispatch(fetchSASUrlError(appError.message));
      }
    }
  };
};
